function Busi() {
  return (
    <div className="inner">
      <h2><b>주요업무</b></h2>
      <nav className="nav-busi">
        <ol>
          <li><a href="#busi1">① 상속/상속포기/한정승인</a></li>
          <li><a href="#busi2">② 민사소송 (지급명령, 내용증명, 소장, 답변서, 준비서면)</a></li>
          <li><a href="#busi3">③ 민사집행 (가압류, 가처분, 채권압류 및 추심, 전부명령)</a></li>
          <li><a href="#busi4">④ 개인회생/파산</a></li>
          <li><a href="#busi5">⑤ 공탁/경매</a></li>
          <li><a href="#busi6">⑥ 기업 법률자문 및 법인등기 (법률자문, 법인설립 및 변경등기)</a></li>
          <li><a href="#busi7">⑦ 부동산등기</a></li>
        </ol>
      </nav>
      <section id="busi1" className="wrap-busi">
        <h3>상속포기와 한정승인</h3>
        <div className="wrap-txt">
          <p>사랑하는 가족의 사망으로 경황이 없는 가운데에서도 여러 가지 상황 등을 고려하여 빠른 시일 내에 우리는 재산을 상속 받을 것인지 아니면 포기할 것인지에 대해 결정을 해야 합니다.</p>
          <p>이와 같은 상황에서 대처할 수 있는 제도인 상속포기와 한정승인의 공통점과 차이점에 대해 설명 드리겠습니다.</p>
          <p>먼저 공통점으로는,<br />상속포기와 한정승인 모두 피상속인(사망하신 고인)이 사망하였을 때 이루어진다는 점이 동일합니다.<br />즉, 피상속인이 살아계실 때에는 상속포기는 물론 한정승인도 할 수 없습니다.</p>
          <p>차이점으로는,<br />상속포기의 경우는 피상속인의 채무가 재산보다 많을 때 채무와 재산 모두를 승계하지 않겠다는 것을 의미합니다.</p>
          <p>상속인이 상속을 포기하게 되면 처음부터 상속인이 아니었던 것이 되어 상속재산은 물론 상속채무 또한 승계 받지 않게 됩니다.(서울고등법원 2011. 2. 22. 선고 2010나 102085 판결)</p>
          <p>하지만 여러 상속인이 있는 가운데 나만 상속포기를 하게 되는 경우에는 어떤 일이 발생할까요?<br />가장 문제가 되는 부분으로는, 사망자의 상속재산보다 상속채무를 더 많이 남기고 돌아가신 상황에서 선순위 상속인인 나만 상속 포기를 할 경우 그 상속채무가 후순위 상속인인 다른 가족에게 채무 등이 상속되는 경우가 발생할 수 있습니다.</p>
          <p>따라서 "나는 상속 포기했으니 모든 빚에서 벗어나게 되겠지? “라고 생각하여 다른 조치 없이 상속 포기만을 할 경우, 그 사망자의 빚은 또 다른 상속인인 내 가족이나 친척들에게 전가되어 버리는 상황이 발생할 수 있습니다.</p>
          <p>그렇다면, 한정승인의 경우는 어떠한 부분이 상속포기와 차이가 있을까요?</p>
          <p>한정승인이란, 상속인이 상속재산의 범위 내에서 망자의 채무와 유증을 변제할 것을 조건으로 상속을 승인하는 것을 말합니다.</p>
          <p>한정승인은 보통 사망인의 상속재산이 상속채무보다 많은지 적은지 명확히 알 수 없는 경우 하게 됩니다.</p>
          <p>상속재산이 상속채무보다 더 많은 경우 법정 상속을 하여 사망자의 재산을 상속인이 상속받으면 되지만, 재산이 더 많은지 빚이 더 많은지 명확하지 않은 경우 한정승인을 함으로써 추후 상속재산이 더 많은 경우 상속채무인 빚을 변제하고 남은 금액에 대해서는 상속을 받고, 이와 반대로 상속채무(빚)가 더 많은 경우 상속재산의 범위 내에서 변제하여 상속인에게 빚이 대물림되는 결과를 방지하게 됩니다.</p>
          <p>이와 같이 상속포기와 한정승인이란 제도는 남아 있는 가족들에게 빚이 대물림되는 상황을 방지하고 우리의 재산을 지킬 수 있는 유용한 제도라 할 수 있습니다.</p>
          <p>다만 이러한 상속포기와 한정승인의 경우 절차가 복잡하기에 여러 번 법원을 방문할 수도 있고, 특별한 사정이 없다면 피상속인(고인)의 사망 후 3개월 이내에 여러 요건 등을 거쳐 위의 절차를 시행해야합니다.</p>
          <p>이에 언제든지 저희 바른 법무사 사무소를 찾아 주시면 모든 방법을 동원하여 원하는 결과를 얻을 수 있도록 확실한 결과 약속드립니다.</p>
        </div>
      </section>
      <section id="busi2" className="wrap-busi">
        <h3>민사소송</h3>
        <div className="wrap-txt">
          <p># 지급명령</p>
          <p>소송의 여러 가지 단계중 빠른 시간에 간이한 방법으로 빌려준 금전 등을 회수 할 수 있는 방법인 지급명령에 대해서 설명 드리도록 하겠습니다.</p>
          <p>지급명령이란,<br />상대방에게 금전 등을 지급받기 위한 목적으로 하는 청구로서, 민사소송절차 중에서도 독촉절차라고 할 수 있습니다.<br />이는 일반적인 민사소송보다 절차가 간이하고 인지대(소장에 붙이는 비용)도 일반적 소송절차의 1/10 에 해당하여 일반적 소송보다 신속, 저렴하게 상대방에게 금전 등을 지급받을 수 있는 제도입니다.</p>
          <p>다만, 절차가 간소하다고는 하지만 이 역시도 민사소송의 일종으로서 확실한 법리적 검토가 필요합니다.</p>
          <p>채권자는 본인의 채권의 종류 등만을 간략하게 밝힌 뒤 법원에 이를 청구하며, 법원 역시 절차상의 검토절차를 거친 뒤 보통 2-3주후 확정이 되는 것으로 신속히 채권을 확보할 수 있는 장점이 있습니다.</p>
          <p>다만, 단점으로는 상대방의 이의제기가 있다면 본안으로 넘어가게 되고, 기판력이 발생하지 않는 점과 상대방의 주소를 알지 못하는 경우에는 시간이 소요되고 본안으로 넘어갈 수 있는 부분이 있습니다.</p>
          <p>지급명령을 포함해서 민사소송의 경우에는 문구 하나하나와 어떤 증거를 제출하고, 기한을 어떻게 기산하며, 이자와 손해액을 어떻게 산정하느냐에 따라 정반대의 결과를 초래할 수도 있습니다.</p>
          <p>특히, 지급명령의 경우에는 잘못된 내용을 기입하여 추후 본안에서 법리적으로 불리하게 작용하게 되는 경우도 발생할 수 있으니, 특히 유의하여야 합니다.</p>
          <p>저희 바른 법무사사무소는, 민사소송 등을 전문분야로서 법무사가 모든 일처리를 직접하며 합리적인 비용으로 최고의 효율로 소송을 진행하여 드릴 것을 약속합니다.</p>
          <p>받지 못한 금전이 있다면 언제든지 저희 바른 법무사사무소로 연락 주시면, 확실한 결과를 만들어 드리겠습니다.</p>
          <p># 답변서</p>
          <p>예상치 못한 상대방에게 갑자기 민사소송을 제기하였다는 소장이 날아와 당황하셨습니까?<br />이때 우리는 상대방의 주장에 대한 반박으로서 답변서를 법원에 제출하게 됩니다.</p>
          <p>즉, 답변서란, 민사소송을 진행함에 있어 상대방의 청구에 대하여 답변 내용을 적은 서류를 의미합니다. 따라서 주로 피고로서 원고의 주장에 대한 부인과 항변을 하기 위한 수단으로서 답변서가 활용 되고 있습니다.</p>
          <p>그 중요성에 대해 설명 드리자면, 소송상 피고의 첫 의사를 확인하는 절차로서 추후 있을 변론에서의 기조나 혹은 재판부가 원고의 청구를 판담함에 있어 매우 중요한 자료서도 판단되고 작용하게 됩니다.</p>
          <p>법원은 피고의 답변서를 확인하고 조정절차나 강제조정 혹은 소각하등 여러 가지 영향을 미칠 수 있습니다.</p>
          <p>따라서 명확한 법리를 찾고 이를 근거로서 답변서를 작성하는 것은 매우 중요한 부분이라 할 수 있습니다.</p>
          <p>위와 같이 원치 않는 송사에 휘말려서 마음 고생하시는 분들은 언제든 저희를 찾아주세요.</p>
          <p>저희 바른 법무사사무소에서는 법무사가 일처리를 직접 하면서, 기초적인 법률검토부터 소송의 전반적인 방향까지 잡아드리겠습니다.<br />이를 통해 소송에 승소할 수 있도록 하겠습니다.</p>
        </div>
      </section>
      <section id="busi3" className="wrap-busi">
        <h3>가압류와 가처분</h3>
        <div className="wrap-txt">
          <p>상대방의 재산에 대해 집행할 수 있는 민사집행에는 가압류, 가처분, 채권압류 및 추심, 전부명령등이 있으며, 이를 통해 우리의 권리를 지킬 수 있습니다. 여기서는 우선 가압류와 가처분에 대해서 살펴보도록 하겠습니다.</p>
          <p>가압류ㆍ가처분이란?</p>
          <p>가압류, 가처분이란 보통 민사소송에는 많은 시간이 걸리므로 상대방이 재산을 은닉·처분할 염려가 있는 경우, 특정권리의 현 상태를 보존해야할 필요가 있는 경우에는 비교적 짧은 기간 내에 이를 처분하거나 사용하지 못하도록 또는 권리침해를 하지 못하도록 하는 것이 가압류·가처분명령입니다.</p>
          <p># 가압류</p>
          <p>1. 가압류란?</p>
          <p>상대방에게 돈을 받기 위한 민사소송절차는 많은 시간이 걸리게 됩니다. 그 사이에 채무자는 재산을 숨기거나 처분 할 수 있는데 채권자로서는 이를 방지할 필요가 있습니다.<br />이러한 경우에 채무자에 대한 사전 통지 없이 보통 10일 이내의 짧은 시일 내에 채무자 재산을 채무자가 처분하지 못하도록 하는 것을 가압류라고 합니다.</p>
          <p>또한 채무자의 거래처 미수금이나 가전제품 등에 가압류를 하면 현실적으로 채무자에게 심리적 압박감을 주어 소송을 하지 않고도 분쟁이 신속하게 해결되기도 합니다.</p>
          <p>가압류를 한 후에도 분쟁이 해결되지 않으면 민사소송절차를 통하여 판결문을 얻은 후 가압류한 채무자의 재산에 대하여 강제집행을 하게 됩니다.</p>
          <p>2. 가압류를 할 수 있는 재산은?</p>
          <p>가압류는 부동산, 자동차, 유체동산(가전제품, 집기, 가구, 기계 등), 채권(급여, 퇴직금, 예금, 임대차보증금, 거래처 미수채권 등), 저작권, 특허권, 상표권, 골프회원권, 예탁주권 등 재산적가치가 있는 채무자의 재산에 대하여 할 수 있습니다.</p>
          <p>3. 가압류 절차</p>
          <p>가압류는 받을 돈(채권)이 있다는 것을 어느 정도 입증할 수 있는 서류(예컨대 차용증, 지불각서, 계약서 등)를 첨부하여 법원에 접수하면 법원에서는 서류만으로 그 사유를 심사하여 인정되면 가압류결정을 하고 이후 가압류집행을 합니다.</p>
          <p>보통의 경우 가압류를 신청하게 되면 법원에서 공탁을 요구 하는데, 이것은 잘못된 부당한 가압류로 인해 채무자가 손해 보는 것을 방지하기 위해 청구채권액의 일정 비율에 해당되는 돈을 법원에 예치하는 것을 의미합니다.</p>
          <p>대부분의 경우에는 일정 비율에 해당하는 현금 외에 보증보험증권으로 내는 것을 허가해주기 때문에 큰 부담은 되지 않으나, 가압류의 종류나 주장 사실의 확실성 정도에 따라 현금을 공탁을 요구하기도 합니다.</p>
          <p>특히 예금채권이나 급여채권 등에 가압류신청 할 경우 대부분의 경우 현금공탁명령이 나오게 됩니다. 다만, 이때의 현금 공탁된 금전은 추후 소송을 제기하여 종료되거나 상대방이 공탁된 금전을 찾는데 동의해주면 찾을 수 있습니다.</p>
          <p>다만 후에 소송이 제기된 경우 가압류한 사람이 소송에서 패소하는 경우 상대방이 공탁된 현금에 대해 권리행사 (부당한 가압류를 원인으로 한 손해배상청구소송에 따라 승소하면 그 부분만큼 배상 받을 수 있음)를 할 수도 있습니다.</p>
          <p>가압류결정이 나오면 부동산가압류의 경우에는 부동산등기부에 가압류된 사실(채권액수와 채권자 인적사항)이 기재되고, 채권가압류의 경우에는 제3채무자(채무자에 돈을 지불할 의무가 있는 사람 즉 채무자의 채무자)에게 가압류결정문이 송달됩니다.</p>
          <p>유체동산가압류의 경우에는 채권자가 결정문을 첨부하여 집행관에게 집행을 의뢰하면 집행관이 채무자의 집이나 사무소에 있는 집기나 전자제품 등 물건에 푸른색의 가압류표목, 소위 ‘딱지’를 붙입니다.</p>
          <p>4. 가압류의 효력</p>
          <p>부동산가압류가 되면 그 부동산을 양도하거나 담보 제공하는 등 처분행위를 못하는 것은 아니지만 가압류권자에게 그 처분행위의 효력을 주장할 수 없습니다.</p>
          <p>채권가압류가 된 경우에는 제3채무자는 채무자에게 돈을 지급할 수 없게 됩니다. 만일 가압류의 효력을 무시하고 채무자에게 돈을 지급한 경우에는 후에 채권자에게 2중으로 돈을 지급해야 되는 상황이 발생 할 수 있습니다.</p>
          <p>유체동산에 가압류가 되면 이를 처분하거나 담보 제공하는 것이 금지됩니다. 그러나 집행관이 특별히 사용을 금지한 경우 아니면 그 동산의 사용을 못하는 것은 아니며 다만 가압류 표목을 손상시켜서는 안되고, 집행관의 허가 없이 다른 장소로 이동해서도 안됩니다.</p>
          <p># 가처분</p>
          <p>1. 가처분이란?</p>
          <p>돈을 받기 위하여 하는 가압류와 달리 가처분은 그 외의 특정한 물건이나 권리를 받기 위한 소송을 제기하기 전에 그 물건에 대한 채무자의 처분을 방지하거나 현상유지를 하고자 할 때 하는 절차입니다.</p>
          <p>다시 말해, 비금전채권을 근거로 하여 임시적으로 재산에 대한 처분을 금지하거나 어떤 행위를 못하게 하는 등의 절차를 말합니다.</p>
          <p>가처분을 한 후에도 분쟁이 해결되지 않으면 민사소송절차를 통하여 판결문을 얻은 후 강제집행을 통하여 가처분한 물건의 소유권을 넘겨받거나 임시가 아닌 종국적인 해결책을 찾게 됩니다.</p>
          <p>예컨대, 어떤 부동산에 대하여 매매계약을 한 경우 매수인(사는 사람)은 매도인(파는 사람)에 대하여 매매대금 지급을 조건으로 부동산 소유권을 이전받을 권리를 갖게 됩니다.</p>
          <p>그런데 매도인에게 매매대금 전부를 지급했음에도 불구하고 매도인이 매수인에게 소유권이전등기를 해주지 않으면 매수인은 부동산의 소유권을 이전하라는 소송을 제기할 수 있습니다.</p>
          <p>하지만, 재판 도중에 부동산의 소유권이 제3자로 변동되면, 매수인은 부동산의 소유권을 확보하기 어렵게 됩니다. 이러한 때 매수인은 소송을 제기하기 전에 매도인이 소유권을 처분하지 못하도록 할 수 있는데 이를 부동산처분금지 가처분이라 합니다.</p>
          <p>그 외에도 점유이전금지 가처분, 공사중지 가처분, 접근금지가처분, 효력정지가처분 등 그 종류가 매우 다양합니다.</p>
          <p>2. 가처분 절차</p>
          <p>가처분신청절차도 가압류신청절차와 비슷하며 부동산처분금지가처분의 경우에는 부동산등기부에 그 사실을 기재해야하므로 등록세 등 세금을 내야하며 공탁을 해야 하는 경우가 대부분입니다.</p>
          <p>가처분결정이 나오면 부동산처분금지가처분의 경우는 법원이 관할 등기소에 등기촉탁을 하여 가처분등기가 되고, 점유이전금지가처분의 경우에는 채권자가 집행관사무소에 집행을 위임하면 집행관이 점유이전금지 등을 기재한 공시서면을 그 물건이 있는 장소에 붙여서 이해관계인들이 볼 수 있게 합니다.</p>
          <p>그 외 가처분 등은 가처분 결정문을 그 의무자에게 송달하는 방식으로 집행을 합니다.</p>
          <p>위와 같이 가압류와 가처분의 경우는 상대방에게 받을 채권이 있는 경우 활용할 수 있으며, 이를 통해 상대방에게 압박감을 주는 동시 소송 등을 통해서 채권을 회수할 수 있는 유용한 방법 중 하나입니다.</p>
          <p>위와 같이 상대방에게 받을 채권을 받지 못해서 마음 고생하시는 분들은 언제든 저희를 찾아주세요.</p>
          <p>저희 바른 법무사사무소에서는 민사집행과 민사소송을 전문분야로서 법무사가 모든 일처리를 직접 처리하고 있습니다.</p>
        </div>
      </section>
      <section id="busi4" className="wrap-busi">
        <h3>개인회생 및 파산</h3>
        <div className="wrap-txt">
          <p>우리의 계획대로 모든 것이 진행되지 않듯이, 여의치 않게 감당할 수 없는 빚으로 인해 어려움을 겪을 수 있습니다.</p>
          <p>이를 타개하고 의뢰인이 다시 한 번 기회를 얻을 수 있는 방법에는 개인회생, 파산 등의 방법이 있습니다. </p>
          <p>먼저, 개인회생과 개인파산절차의 차이에 대해서 말씀 드리겠습니다.</p>
          <div className="wrap-tbl">
            <table>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>개인회생</th>
                  <th>개인파산</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>이용대상</th>
                  <td>개인채무자로서 급여소득자나 영업소득자</td>
                  <td>제한 없음</td>
                </tr>
                <tr>
                  <th>신청원인</th>
                  <td>파산의 원인인 사실이 있거나 그러한 사실이 생길 염려</td>
                  <td>파산의 원인인 사실</td>
                </tr>
                <tr>
                  <th>변제재원</th>
                  <td>장래 채무자의 소득</td>
                  <td>파산선고 당시의 파산재단</td>
                </tr>
                <tr>
                  <th>채무액수 제한</th>
                  <td>무담보부 10억원, 담보부 15억원 이하</td>
                  <td>제한 없음</td>
                </tr>
                <tr>
                  <th>채무조정 수준</th>
                  <td>장래소득으로서 3년간(예외 5년간) 변제</td>
                  <td>장래 소득 변제 불요</td>
                </tr>
                <tr>
                  <th>불이익 유무</th>
                  <td>불이익 없음(채무자회생법 제32조의2)</td>
                  <td>각종 법률에서의 직업상의 결격사유 해당(공무원, 공공기관 임원 등으로 당연퇴직 사유, 학원 설립운영 등록제한)</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>절차가 복잡하고 인가결정이 상대적으로 어려운 개인회생절차이지만, 채무자가 현재 보유하고 있는 재산을 청산하여 변제하는 파산절차와는 달리 법률적인 불이익이 없고, 원칙적으로 채무자가 현재 보유하고 있는 재산을 유지하고 장래 수입중 생계비등을 제외하고 일정부분의 변제로서 모든 채무로부터 자유로워질 수 있는 개인회생 절차에 대해 알아보도록 하겠습니다.</p>
          <p><strong>개인회생 절차</strong></p>
          <p>1. 신청 자격 확인</p>
          <p>개인 회생은 본인이 원한다고 신청할 수 있는 것이 아니라, 일정한 자격 요건을 갖춘 경우에 한하여 신청할 수 있습니다.</p>
          <p>기본적인 개인 회생 신청 요건은 아래와 같습니다.</p>
          <p>1) 채무가 재산보다 많을 것.</p>
          <p>2) 장래에 계속적 또는 반복적인 수입이 있을 것.</p>
          <p>3) 채무는 무담보 10억, 담보부 15억 이하</p>
          <p>4) 개인회생 면책결정을 받은 경험이 있는 경우 5년이 지난 후 일 것.</p>
          <p>2. 서류 준비</p>
          <p>개인회생절차는 채무자의 빚을 일정부분만 남기고 나머지는 탕감을 해주는 제도이기에 까다로운 기준을 가지고 있으며 많은 서류 및 보강 자료가 제출되어야 합니다.</p>
          <p>이는 개인이 준비하기에는 어려운 부분이며, 또한 잘못된 자료의 제출로 인해 개인회생절차가 기각되는 경우가 비일비재하게 발생하여, 의뢰인분들의 금전적 시간적 막대한 손실이 발생할 수 있습니다. 이에 바른 법무사사무소에 내방하시여 상담 진행하실 경우 합리적인 금액으로 반드시 원하시는 결과를 얻을 수 있도록 최선을 다할 것임을 약속드립니다.</p>
          <p>3. 금지명령 및 중지명령</p>
          <p>개인회생 절차의 신청을 통해서 의뢰인분들이 더 이상은 채권자들에게 강제집행, 가압류, 가처분 및 독촉행위를 할 수 없도록 금지명령과 중지 명령을 신청하여 더 이상 채권추심에 시달리지 않고, 안정적인 생활을 할 수 있도록 조치를 취해 드립니다.</p>
          <p>이에, 개인회생 신청서를 법원에 제출함과 동시에 금지명령 신청서도 법원에 함께 제출하고, 대략적으로 개인회생 신청을 한 날로부터 14일 내에 금지명령 및 중지명령을 받을 수 있도록 조치를 취해 드립니다.</p>
          <p>이러한 금지명령과 중지 명령을 통해서, 채권자들로 하여금 더 이상 의뢰인의 재산에 대하여 강제집행·가압류·가처분 및 독촉 행위 등을 금지/중지하게 할 수 있습니다.</p>
          <p>4. 보정명령</p>
          <p>보정명령이란 채무자가 개인회생 신청 당시 제출한 자료들에 허위 또는 미흡한 사실이 있는 경우 이를 명확하게 위하여 법원이 제출한 서류의 보정을 명하거나 추가 서류의 제출을 요구하는 절차입니다.</p>
          <p>개인회생절차의 인가를 받기 위한 까다로운 작업 중에 하나라고도 할 수 있습니다. 법원에 의해 요구되는 여러 번의 수정과 보완의 과정을 거치게 되며, 각각의 보정명령후 7일 이내에 수정 보완하지 못할 경우 개인회생 신청이 기각될 수도 있습니다.</p>
          <p>5. 개인회생 개시 결정</p>
          <p>모든 보정명령이 완료되고 기각사유가 없으며, 법원이 요구하는 모든 사실 자료가 올바르게 제출된 경우 대략 1개월의 기간 안에 개시 결정이 내려 질수 있습니다.</p>
          <p>6. 채권자 이의 및 채권조사확정재판</p>
          <p>7. 채권자집회</p>
          <p>8. 변제계획인가 결정</p>
          <p>9. 면책</p>
          <p>면책 결정후 법원은 신용정보원에 판결문을 송달하게 되고, 판결문을 송달받은 신용정보원에서는 연체와 관련된 채무자의 모든 정보를 삭제하게 됩니다. 이에 신용불량자등인 의뢰인은 이에서 해방되게 되는 것이며, 정상적인 사회생활을 영위해 나갈 수 있습니다.</p>
          <p>위와 같이 여러 채무 등으로 인해 개인회생이나 파산 등을 고려하고 계시다면 언제든 저희를 찾아주세요.</p>
          <p>저희 바른 법무사사무소에서는 개인회생과 파산을 전문분야로서 법무사가 모든 일처리를 직접 처리하고 있습니다.</p>
        </div>
      </section>
      <section id="busi5" className="wrap-busi">
        <h3>공탁</h3>
        <div className="wrap-txt">
          <p>공탁이란 단어를 한번쯤은 들어 보셨을 수 있습니다. 그렇다면 공탁이란 어떠한 제도이며, 언제 공탁이란 제도를 활용할 수 있는지 알아보는 시간을 갖도록 하겠습니다.</p>
          <p>먼저, 공탁이란 무엇일까요?</p>
          <p>공탁은 상대방에게 일정한 의무가 있는 경우 이에 그 상대방 대신 법원의 공탁소에 금전, 유가증권, 물품 등을 맡김으로써 일정한 의무에서 벗어나는 것을 말합니다. </p>
          <p>예컨대, 우리가 흔히 공탁이라고 하는 것은 상대방에게 돈을 갚아야할 의무가 있는데 상대방이 어떤 사유에서건 그 돈을 받으려고 하지 않을 때, 공탁소(법원 공탁과)에 그 돈을 맡김으로써 돈 갚을 의무에서 벗어나려고 하는 경우를 말하는 것입니다.</p>
          <p>이는 법률상 ‘변제공탁’이라고 하는데 공탁은 이외에도 담보공탁(보증공탁), 집행공탁 등 여러 가지가 있으며 여기서는 위 세 가지 공탁에 대해서 살펴보도록 하겠습니다.</p>
          <p>1.변제공탁</p>
          <p>변제공탁은 상대방에게 돈을 변제해야할 의무가 있지만, 그 상대방이 돈을 받기를 거부하거나 받을 수 없는 상태, 심지어 변제를 받아야 할 상대방이 구체적으로 누군지 모르는 경우에 실시하는 공탁을 변제공탁이라 합니다.</p>
          <p>예컨대, 이런 경우 공탁을 하지 않는다면 채무자는 채무의 변제를 할 수 없기 때문에 그 채무에서 벗어 날수 없으며 이자도 추후 지급해야 하는 경우도 발생하게 됩니다. </p>
          <p>이런 경우 변제공탁을 하게 되면 상대방이 공탁된 돈의 수령 여부를 불문하고 법률상 변제한 것으로 취급하여 채무에서 벗어날 수 있습니다.</p>
          <p>2. 담보공탁(보증공탁)</p>
          <p>우리가 상대방에게 받을 돈이 있는 채권자인 경우 채권의 회수를 위해 가압류 등을 실시할 수 있습니다. 이때 법원은 채무자인 상대방에게 손해를 발생시킬 우려가 있다고 판단되는 경우 채권자에게 일정 금액의 공탁을 요구하게 되는데 이를 담보공탁이라고 합니다.</p>
          <p>이는 장차 상대방에게 발생할 수 있는 손해배상청구권을 담보하기 위해서 하는 공탁을 의미하는 것입니다.</p>
          <p>다시 말하자면, 가압류신청을 하는 경우에 법원에서 가압류신청자(채권자)에게 공탁을 명할 수 있는데 이것이 바로 담보공탁입니다.</p>
          <p>3. 집행공탁</p>
          <p>이는 보통 강제집행과정에서 집행의 목적물(보통, 금전)을 공탁소에 공탁하는 것을 말합니다.<br />예를 들면, 채권압류 및 추심명령에 따라 추심채권자가 제3채무자로부터 금전을 추심하여 받았으나 채권자가 여럿인 경우 배당절차를 거치기 위해 추심한 돈을 공탁소에 공탁하는 경우를 말합니다.<br />공탁된 돈은 나중에 법원의 배당절차에 따라 채권자들에게 배당순위에 따라 배당됩니다.</p>
          <p>예컨대, 아파트를 소유하고 있는 우리가 상대방에게 전세를 주고 있습니다. 이때 전세를 살고 있는 임차인의 채권자가 아파트 소유자(임대인)인 우리를 상대로 그 반환하여야 할 전세금 반환채권에 소유주인 우리를 제3채무자로 하여 압류, 가압류를 신청할 수 있습니다.</p>
          <p>이후 아파트 전세기간이 만료된 상황에서 전세 세입자에게 전세금을 반환해야 할까요? 아니면 우리를 상대로 압류, 가압류 신청을 한 세입자의 채권자에게 전세금을 반환해야 할까요.</p>
          <p>위의 경우 아파트 소유주(임대인)인 우리는 누구에게 반환해야 할지 명확하지 않은 상황에 처할 수 있고, 이때 이와 같은 공탁 제도를 활용하여 우리의 고민을 덜어 버릴 수 있습니다.</p>
          <p>- 집행공탁의 장점</p>
          <p>집행공탁을 하면, 세입자에게도 전세금반환 독촉을 받지 않고 반환지연 책임도 물지 않습니다.<br />세입자의 채권자들은, 이제 법원 배당계에서 그 순위에 따른 배당을 기다리면 됩니다.</p>
          <p>- 집행공탁의 비용</p>
          <p>공탁을 하는 경우 필연적으로 비용이 발생하게 됩니다. 나는 채무자도 아닌 단지, 채무자인 세입자에게 전세를 준 일명, 제3채무자에 불과한데 제3채무자로서 압류·가압류 당한 것도 억울하지 싶은데 내 비용을 들여 공탁을 해야 할까요?</p>
          <p>이러한 집행공탁에 있어 제3채무자가 그 지출한 비용은 공탁사유 신고서 제출 이전까지 비용계산서 등을 제출함으로써 배당법원에 그 비용을 청구할 수 있습니다.</p>
          <p>- 집행공탁시 유의사항</p>
          <p>압류·가압류가 경합한 것 외에도, 채권양도통지 또는 세무서 등 에 의한 체납처분에 의한 압류 등이 혼합된 경우가 있습니다.<br />채권양도 통지는 제3채무자에게 그 도달된 선·후 또는 채권양도의 유·무효에 따라 집행공탁이 아닌 혼합 공탁에 해당할 수 있으므로 전문가와 항상 상의를 요합니다.<br />체납처분에 의한 세무서 등의 압류는 다른 (가)압류와 경합으로 보지 않고, 별도로 우선 지급사유에 해당하는 경우가 많으므로 이때에도 전문가의 검토를 요합니다.</p>
          <p>위와 같이 상대방에게 변제 등을 해야 하나 방법을 몰라서, 또한 누구에게 해야 하는지 어리둥절한 상황에 처한 경우로 인해 마음 고생하시는 분들은 언제든 저희를 찾아주세요.</p>
          <p>문정동 동부지방법원앞에 위치한 저희 바른 법무사사무소에서는 법무사가 모든 일처리를 직접 처리하고 있습니다.</p>
        </div>
      </section>
      <section id="busi6" className="wrap-busi">
        <h3>법인설립등기 절차 및 비용</h3>
        <div className="wrap-txt">
          <p>1) 법인설립이 필요한 경우</p>
          <p>1인 기업 또는 개인 사업자가 사업의 성장과 더 큰 발판을 마련하고자 할 때 법인 설립에 대해 관심을 가질 수 있습니다. 이런 법인은 상대적으로 자금의 확보와 대외적인 홍보 및 다른 기업체와 거래를 할 때 유리한 경우도 많고 일정 매출 이상의 경우에는 절세의 효과도 누릴 수 있어 이런 경우 법인 설립 후 법인설립등기를 하는 것이 좋은 방법입니다.</p>
          <p>2) 법인사업자란?</p>
          <p>일반적인 사람 즉, 자연인 이외의 것을 뜻하며 법률에 의하여 권리능력이 인정된 단체, 재산 또는 법적인 독립체를 의미 합니다.</p>
          <p>개인들의 생명과 능력은 한도가 있기 때문에 어느 정도의 대규모이면서 비교적으로 영속적인 사업을 경영하기 위해 여러 사람의 협력 또는 일정 목적을 위해 바쳐진 재산이 필요하게 되는데 이런 이유로 실체가 되는 것은 사람들이 집합한 것(사단)과 재산이 집합한 것(재단)이 있습니다.</p>
          <p>이러한 것들에 법률에 의해 권리능력이 부여된 것을 법인사업자라 합니다.</p>
          <p>3) 회사의 분류</p>
          <p># 영리법인</p>
          <p>① 합명회사 : 여러 명이 합작하여 사업을 운영</p>
          <p>② 합자회사 : 두 명 이상이 합작하여 운영</p>
          <p>③ 유한회사 : 주주 수가 제한된 법인, 주주들 책임의 제한</p>
          <p>④ 주식회사 : 주식을 발행하여 운영</p>
          <p>⑤ 유한책임회사 : 주주의 책임이 제한됨</p>
          <p># 비영리법인</p>
          <p>① 사단법인 : 사람이 모인단체 / 사회, 문화, 종교적 목적을 위해 활동</p>
          <p>② 재단법인 : 재산이 모인 단체 / 사회적 목적을 위해 활동</p>
          <p>4) 법인설립 절차 및 유의사항</p>
          <p>법인설립 등기시 무엇보다 중요한 부분은 회사 상호명을 결정해야 합니다. 회사명은 중복되지 않아야 하고 한글로 작성되어야 하며 숫자만으로 구성하거나 영문, 특수기호등은 사용할 수 없습니다.</p>
          <p>① 회사상호명 짓기</p>
          <p>* 대법원인터넷등기소(www.iros.go.kr)에 상호 검색후 관할 구역 내 중복되지 않는 상호명 선택하여야 합니다.</p>
          <p>* 한글로 작성되어야 함</p>
          <p>* 숫자만으로 구성하거나 영문, 특수기호 포함 금지</p>
          <p>② 자본금</p>
          <p>* 설립 및 운영을 위한 기본자금으로서, 최소 100원 부터 설립 가능</p>
          <p>* 총 자본금과 액면가를 바탕으로 총 발행주식 수 결정</p>
          <p>③ 본점 소재지</p>
          <p>* 회사의 소재지로서 주소를 의미 합니다.</p>
          <p>* 자택을 본점으로 하고 싶은 경우, 영위 업종과 관할 규정에 따라 가능합니다.</p>
          <p>* 본점소재지의 주소에 따라 등록면허세가 최대 3배까지 차이가 있을 수 있습니다.</p>
          <p>④ 회사 사업 목적 결정</p>
          <p>* 회사가 영위할 사업에 대해 구체적으로 결정하여야 합니다. 예컨대 출판업 등으로 광범위하게 기재해서는 안되며 서적, 잡지 및 기타 인쇄물 출판업으로 구체적으로 결정하여야 합니다.</p>
          <p>* 통계청 통계분류포털 - 한국표준산업분류표 참고 가능</p>
          <p>⑤ 임원</p>
          <p>* 이사와 감사를 포함한 임원진 구성 필요</p>
          <p>* 자본금이 10억 미만일 경우, 감사를 선임하지 않아도 됩니다.</p>
          <p>- 위의 과정은 필요 과정의 일부분만 기재한 것으로서 이외에 정관, 주주명부, 법인인감, 잔고증명서 및 공고 방법 등 법률의 요건에 부합하는 사항을 충족한 후 법인 설립등기 신청을 하게 됩니다.</p>
          <p>5) 법인설립등기 완료</p>
          <p>법인설립등기 완료 후에는 관할세무서 혹은 홈택스에서 사업자등록을 진행하게 법인설립이 완료됩니다.</p>
          <p>법인설립절차는 정관작성등 제출하는 서류와 방법 등이 까다롭고 복잡하여 혼자서 진행하기에는 어려움을 겪으실 수 있습니다.</p>
          <p>이에 송파구 문정동 동부지방법원 앞에 위치한 저희 바른 법무사사무소는 법무사가 모든 일처리를 직접 처리하며, <u>합리적인 비용으로 빠른 시간 안에</u> 원하시는 사업체를 운영하실 수 있도록 법인 설립등기 절차를 진행하여 드리고, 법인설립이후에도 <u>지속적인 법률자문</u> 등의 지원을 아끼지 않을 것을 약속드립니다.</p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
      </section>
      <section id="busi7" className="wrap-busi">
        <h3>부동산등기</h3>
        <div className="wrap-txt">
          <p>부동산 등기란 각각의 부동산에 대해서 그 소유의 형태를 누구든지 알 수 있도록 공시하는 제도를 의미합니다.<br />예컨대, 건물이나 토지 등과 같은 부동산의 경우 주머니에 넣거나 금고에 보관하는 등의 방법으로 그 소유를 주장할 수 없는 물건이기에, 누구의 소유인지 여부를 모든 사람들에게 알려주기 위한 제도라 할 수 있습니다.</p>
          <p>부동산등기는 누구의 소유인지를 공시하는 소유권뿐만 아니라 은행에 금전을 차용한 경우 채무가 어느 정도 있다는 것도 공시할 수 있는 근저당권, 또한, 부동산을 임차한 후 설정할 수 있는 전세권 및 임차권등기명령등 다양한 방법으로 그 부동산의 권리관계를 공시 할 수 있습니다.</p>
          <p>그렇다면, 이런 부동산에 등기를 하는 이유에 대해서 설명 드리겠습니다.<br />부동산등기를 하게 되면 4가지의 효력을 얻을 수 있습니다.</p>
          <p>먼저, 권리변동효력이 발생하게 됩니다.<br />컨대, 매매계약이후 부동산등기를 진행하게 되면 대외적으로 그 부동산의 소유자임을 공시하게 되는 효과를 볼 수 있습니다.</p>
          <p>두 번째로는 순위확정적인 효력을 가지고 있습니다.<br />내가 상대방에게 금전을 빌려준 후 저당권 설정등기를 하여야만 그 이후의 또 다른 저당권자보다 우선적인 권리를 가지게 되는 것입니다.<br />이는 추후 그 부동산이 경매 등에 처하는 경우 배당 순위를 결정하는데 아주 중요한 요소가 되는 부분입니다.</p>
          <p>세 번째로는 대항력을 가진다고 할 수 있습니다.<br />이는 특정한 법률관계에서 제 3자에게 부동산등기에 대해 그 권리를 주장할 수 있는 효력을 의미하며 등기부에 기재된 순위에서도 우선적으로 보호를 받거나 권리에 대항할 수 있는 효력을 의미합니다.</p>
          <p>위와 같이 부동산등기의 경우 매우 중요한 부분이며, 또한 서류작성의 실수 등으로 인해 접수 시기 등이 늦춰질 경우 순위가 뒤로 밀리는 등의 막대한 재산상 손해가 발생할 수도 있는 중요한 부분입니다.</p>
          <p>위와 같이 소유권이전등기, 근저당권설정등기, 전세권 및 임차전설정등기등이 필요하신 분들은 언제든 저희를 찾아주세요.</p>
          <p>송파구 문정동 동부지방법원앞에 위치한 저희 바른 법무사사무소에서는 부동산등기업무에 대해 법무사가 모든 일처리를 직접 처리하고 있습니다.</p>
        </div>
      </section>

      <aside className="aside-right">
        <div className="wrap-info">
          <h3><b>바른</b> 법무사 사무소</h3>
          <ul className="list-loca">
            <li className="ico-address">서울 송파구 법원로8길 13 3층 315호<br />(문정동, 문정헤리움써밋타워)</li>
            <li className="ico-phone">전화 : 02-448-2207</li>
            <li className="ico-fax">팩스 : 02-449-2207</li>
            <li className="ico-email">이메일 : lawbareun@naver.com</li>
            <li className="ico-blog"><a href="https://blog.naver.com/lawbareun" className="btn-naverBlog" target="blank">블로그</a></li>
          </ul>
        </div>
        <div className="wrap-btn">
          <a href="#top" title="맨 위로"></a>
        </div>
      </aside>
    </div>
  );
}

export default Busi;
